document.addEventListener('DOMContentLoaded', function () {

  const hasHover = window.matchMedia('(hover: hover)').matches;

  // Remove foco residual em dispositivos sem hover, de forma sincronizada
  if (!hasHover) {
    requestAnimationFrame(() => {
      if (document.activeElement && document.activeElement.matches('[data-wpmundi-megamenu="true"]')) {
        document.activeElement.blur();
      }
    });
  }

  const menuItems = document.querySelectorAll('[data-wpmundi-megamenu="true"]');
  const openMenus = new Map();

  // Garante estado inicial fechado
  document.querySelectorAll('.wpmundi-mega-menu-area').forEach(m => m.classList.remove('is-open'));
  menuItems.forEach(li => li.classList.remove('is-megamenu-open'));

  const closeAllExcept = (exceptId = null) => {
    // Fecha todos os menus abertos, exceto o informado
    openMenus.forEach((menu, id) => {
      if (id !== exceptId) {
        menu.classList.remove('is-open');
        const trigger = document.getElementById(id);
        const li = trigger ? trigger.closest('li') : null;
        if (li) li.classList.remove('is-megamenu-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        openMenus.delete(id);
      }
    });
  };

  const reposition = (item, relatedMenu) => {
    const rect = item.getBoundingClientRect();
    relatedMenu.style.top = `${rect.bottom + window.scrollY}px`;

    // Reset posicionamento horizontal
    relatedMenu.style.left = '';
    relatedMenu.style.right = '';
    relatedMenu.style.transform = '';

    if (relatedMenu.classList.contains('align-full')) {
      // nada
    } else if (relatedMenu.classList.contains('align-left')) {
      relatedMenu.style.left = `${rect.left + window.scrollX}px`;
    } else if (relatedMenu.classList.contains('align-right')) {
      relatedMenu.style.right = `${window.innerWidth - rect.right}px`;
    } else if (relatedMenu.classList.contains('align-center')) {
      const center = rect.left + (rect.width / 2);
      relatedMenu.style.left = `${center + window.scrollX}px`;
      relatedMenu.style.transform = 'translateX(-50%)';
    } 
  };

  const recalcAll = () => {
    openMenus.forEach((menu, id) => {
      const item = document.getElementById(id);
      if (item && document.body.contains(item)) {
        reposition(item, menu);
      } else {
        // Trigger sumiu do DOM, remove referência
        openMenus.delete(id);
      }
    });
  };
  window.addEventListener('scroll', recalcAll, { passive: true });
  window.addEventListener('resize', recalcAll);

  // ESC fecha todos
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAllExcept(null);
    }
  });

  menuItems.forEach(item => {
    const targetId = item.getAttribute('id');
    const relatedMenu = document.querySelector(
      `.wpmundi-mega-menu-area[data-wpmundi-megamenu-target="${targetId}"]`
    );
    if (!relatedMenu) return;

    // ARIA (melhora acessibilidade)
    item.setAttribute('aria-expanded', 'false');
    item.setAttribute('aria-controls', `wpmundi-megamenu-${targetId}`);
    relatedMenu.id = relatedMenu.id || `wpmundi-megamenu-${targetId}`;
    relatedMenu.setAttribute('aria-hidden', 'true');

    const parentLi = item.closest('li');

    const showMegaMenu = () => {
      reposition(item, relatedMenu);
      // Fecha outros antes de abrir este
      closeAllExcept(targetId);

      relatedMenu.classList.add('is-open');
      if (parentLi) parentLi.classList.add('is-megamenu-open');
      item.setAttribute('aria-expanded', 'true');
      relatedMenu.setAttribute('aria-hidden', 'false');
      openMenus.set(targetId, relatedMenu);
    };

    const hideMegaMenu = () => {
      relatedMenu.classList.remove('is-open');
      if (parentLi) parentLi.classList.remove('is-megamenu-open');
      item.setAttribute('aria-expanded', 'false');
      relatedMenu.setAttribute('aria-hidden', 'true');
      openMenus.delete(targetId);
    };

    const toggleMegaMenu = () => {
      if (relatedMenu.classList.contains('is-open')) {
        hideMegaMenu();
      } else {
        showMegaMenu();
      }
    };

    // --- Hover para telas com suporte ---
    if (hasHover) {
      item.addEventListener('mouseenter', showMegaMenu);
      item.addEventListener('mouseleave', (e) => {
        if (relatedMenu.contains(e.relatedTarget)) return;
        hideMegaMenu();
      });

      relatedMenu.addEventListener('mouseleave', (e) => {
        if (e.relatedTarget === item) return;
        hideMegaMenu();
      });

      // Hover inicial no carregamento
      if (item.matches(':hover')) {
        item.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
      }
    }

    // --- Clique para toggle ---
    item.addEventListener('click', (e) => {
      e.stopPropagation(); // impede que seja captado como "fora"
      e.preventDefault();
      toggleMegaMenu();
      if (!hasHover) {
        // Em telas sem hover, remove foco para não deixar :focus visível
        item.blur();
      }
    });

    // --- Acessibilidade ---
    if (hasHover) {
      // Apenas em telas com hover usamos focusout
      relatedMenu.addEventListener('focusout', (e) => {
        if (!relatedMenu.contains(e.relatedTarget)) hideMegaMenu();
      });
      item.addEventListener('focusout', (e) => {
        if (!relatedMenu.contains(e.relatedTarget)) hideMegaMenu();
      });
    }
  });

  // Clique fora — fecha todos os menus abertos (mantido e simplificado)
  document.addEventListener('click', (e) => {
    // Se clicou fora de qualquer trigger e fora de qualquer menu, fecha todos
    if (
      !e.target.closest('[data-wpmundi-megamenu="true"]') &&
      !e.target.closest('.wpmundi-mega-menu-area')
    ) {
      closeAllExcept(null);
    }
  });
});
